<template>
  <thead>
    <slot />
  </thead>
</template>

<style lang="postcss" scoped>
thead {
  border-bottom: 1px solid var(--color-gray-200);
}
</style>
